module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": "",
      "px-0": "",
      "py-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "secondary timepicker-button",
    attrs: {
      "block": "",
      "large": ""
    },
    on: {
      "focus": function($event) {
        _vm.expanded = true
      },
      "keypress": function($event) {
        $event.stopPropagation();
        return _vm.handleKeys($event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "position": "relative"
    }
  }, [_c('span', {
    staticStyle: {
      "left": "0",
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.description) + "\n      ")])])]), _vm._v(" "), (_vm.expanded) ? _c('v-layout', _vm._b({
    attrs: {
      "transition": "expand",
      "wrap": ""
    }
  }, 'v-layout', _vm.orientation, false), [_vm._l((_vm.buttons), function(button, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('v-btn', {
      staticClass: "timepicker-button",
      class: {
        primary: button.selected
      },
      attrs: {
        "block": "",
        "large": "",
        "outline": !button.selected
      },
      on: {
        "click": function($event) {
          _vm.select(button)
        }
      }
    }, [_vm._v(_vm._s(button.label))])], 1)
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "xs12": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "offset-md4": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    ref: "hour",
    staticClass: "text-xs-center display-1",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "type": "number",
      "single-line": "",
      "outline": ""
    },
    on: {
      "focus": function($event) {
        _vm.$nextTick(function () { return $event.target.select(); })
      }
    },
    model: {
      value: (_vm.hour),
      callback: function($$v) {
        _vm.hour = $$v
      },
      expression: "hour"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    ref: "minute",
    staticClass: "text-xs-center display-1",
    attrs: {
      "type": "number",
      "single-line": "",
      "outline": ""
    },
    on: {
      "focus": function($event) {
        _vm.$nextTick(function () { return $event.target.select(); })
      }
    },
    model: {
      value: (_vm.minute),
      callback: function($$v) {
        _vm.minute = $$v
      },
      expression: "minute"
    }
  })], 1)], 1)], 2) : _vm._e()], 1)
},staticRenderFns: []}